function replaceString(text: string, searchValue: string, newValue: string) {
  return text.replace(searchValue, newValue);
}

export default replaceString;
